import React, { useEffect, useState } from 'react';
import config from '../../config';
import './Restaurants.css';
import { FiTrash, FiSlash, FiUnlock, FiEdit2 } from 'react-icons/fi';
import { Modal, Button } from 'react-bootstrap';

export default function Restaurants() {
    const [restaurants, setRestaurants] = useState([]);
    const [filteredRestaurants, setFilteredRestaurants] = useState([]);
    const [expandedRows, setExpandedRows] = useState({});
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [showEditModal, setShowEditModal] = useState(false);
    const [editingRestaurant, setEditingRestaurant] = useState(null);
    const { API_URL } = config;

    useEffect(() => {
        fetchRestaurants();
    }, [API_URL]);

    const fetchRestaurants = async () => {
        try {
            const res = await fetch(`${API_URL}/api/auth/fetchAllRestaurants`);
            const data = await res.json();
            setRestaurants(data.restaurants || []);
            console.log(data.restaurants)
            setFilteredRestaurants(data.restaurants || []);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching restaurants:", error);
            setLoading(false);
        }
    };

    const toggleRow = (id) => {
        setExpandedRows((prevState) => ({
            ...prevState,
            [id]: !prevState[id],
        }));
    };
    const handleToggleBan = async (restaurant) => {
        const _id = restaurant._id;
        const newBanStatus = !restaurant.isBanned;
    
        try {
            const res = await fetch(`${API_URL}/api/auth/updateBanRestaurant/${_id}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ ban: newBanStatus }),
            });
            const data = await res.json();
            alert(data.message);
            if (data.executed) fetchRestaurants(); // this refreshes the list and icon
        } catch (error) {
            console.error("Error toggling ban:", error);
        }
    };
    
    const handleSearchTermChange = (event) => {
        const searchValue = event.target.value.toLowerCase();
        setSearchTerm(searchValue);
        filterRestaurants(searchValue, statusFilter);
    };

    const handleStatusFilterChange = (status) => {
        setStatusFilter(status);
        filterRestaurants(searchTerm, status);
    };

    const filterRestaurants = (searchValue, status) => {
        const filtered = restaurants.filter((restaurant) =>
            (restaurant.nukkadName.toLowerCase().includes(searchValue) ||
                restaurant.city.toLowerCase().includes(searchValue) ||
                restaurant.ownerName.toLowerCase().includes(searchValue) ||
                restaurant.phoneNumber.includes(searchValue)) &&
            (status === 'all' || restaurant.status === status)
        );
        setFilteredRestaurants(filtered);
    };

    const handleDelete = async (id) => {
        if (window.confirm("Are you sure you want to delete this restaurant?")) {
            try {
                const res = await fetch(`${API_URL}/api/auth/DeleteRestaurantById`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id }),
                });
                const data = await res.json();
                alert(data.message);
                if (data.executed) fetchRestaurants();
            } catch (error) {
                console.error("Error deleting restaurant:", error);
            }
        }
    };

    const handleEdit = (restaurant) => {
        setEditingRestaurant({...restaurant});
        setShowEditModal(true);
    };

    const handleEditChange = (field, value) => {
        setEditingRestaurant(prev => ({...prev, [field]: value}));
    };

    const handleNestedChange = (parent, field, value) => {
        setEditingRestaurant(prev => ({
            ...prev,
            [parent]: {...prev[parent], [field]: value}
        }));
    };

    const handleUpdateRestaurant = async () => {
        try {
            const { _id, ...updateData } = editingRestaurant;
            const res = await fetch(`${API_URL}/api/auth/updateRestaurantById`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ _id, updateData }),
            });
            const data = await res.json();
            alert(data.message || 'Restaurant updated successfully');
            setShowEditModal(false);
            fetchRestaurants();
        } catch (error) {
            console.error("Error updating restaurant:", error);
            alert("Failed to update restaurant");
        }
    };

    const formatPhoneNumber = (phone) => {
        if (!phone) return '';
        // Remove +91 prefix if it exists and return last 10 digits
        return phone.replace('+91', '').slice(-10);
    };

    if (loading) {
        return (
            <div className='d-flex flex-column ' style={{ height: "98vh", maxWidth: "100vw", justifyContent: "center", alignItems: "center" }}>
                <div className="spinner-grow text-success" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    return (
        <div className="restaurants-container p-8">
            <h1 className="text-2xl font-bold mb-4">RESTAURANTS</h1>

            <input
                type="text"
                value={searchTerm}
                onChange={handleSearchTermChange}
                placeholder="Search by nukkad name, city, owner name or phone number..."
                className="form-control mb-3 rounded-xl"
            />

            <div className="mb-3">
                <button
                    className={`btn btn-${statusFilter === 'all' ? 'primary' : 'secondary'} me-2`}
                    onClick={() => handleStatusFilterChange('all')}
                >
                    All
                </button>
                <button
                    className={`btn btn-${statusFilter === 'verified' ? 'primary' : 'secondary'} me-2`}
                    onClick={() => handleStatusFilterChange('verified')}
                >
                    Verified
                </button>
                <button
                    className={`btn btn-${statusFilter === 'unverified' ? 'primary' : 'secondary'}`}
                    onClick={() => handleStatusFilterChange('unverified')}
                >
                    Unverified
                </button>
            </div>

            <table className="table table-hover bg-white rounded-tr-lg">
                <thead className="table-light">
                    <tr>
                        <th scope="col" className="rounded-tl-lg">Nukkad Name</th>
                        <th scope="col">Owner Name</th>
                        <th scope="col">Nukkad Address</th>
                        <th scope="col">Phone No.</th>
                        <th scope="col">Status</th>
                        <th scope="col">More</th>
                        <th scope="col" className="rounded-tr-lg bg-red-900">Action</th>
                    </tr>
                </thead>

                <tbody>
                    {filteredRestaurants.map((restaurant) => (
                        <React.Fragment key={restaurant._id}>
                            <tr>
                                <td>{restaurant.nukkadName}</td>
                                <td>{restaurant.ownerName}</td>
                                <td>{restaurant.nukkadAddress}</td>
                                <td>{formatPhoneNumber(restaurant.phoneNumber)}</td>
                                <td>{restaurant.status}</td>
                                <td>
                                    <button
                                        onClick={() => toggleRow(restaurant._id)}
                                        className="btn btn-link"
                                    >
                                        {expandedRows[restaurant._id] ? '▲' : '▼'}
                                    </button>
                                </td>
                                <td>
                                    <button
                                        className="btn btn-sm text-primary"
                                        onClick={() => handleEdit(restaurant)}
                                        title="Edit"
                                    >
                                        <FiEdit2 size={18} />
                                    </button>
                                    <button
                                        className="btn btn-sm text-danger"
                                        onClick={() => handleDelete(restaurant._id)}
                                        title="Delete"
                                    >
                                        <FiTrash size={18} />
                                    </button>
                                    <button
                                      className={`btn btn-sm ${restaurant.isBanned ? 'text-success' : 'text-warning'}`}
                                      onClick={() => handleToggleBan(restaurant)}
                                      title={restaurant.isBanned ? "Unban Restaurant" : "Ban Restaurant"}
                                    >
                                       {restaurant.isBanned ? <FiUnlock size={18} /> : <FiSlash size={18} />}
                                    </button> 
 
                                </td>
                            </tr>
                            {expandedRows[restaurant._id] && (
                                <tr>
                                    <td colSpan="7" className="expanded-row">
                                        <div className="flex justify-between items-start mb-3">
                                            <h4 className="font-semibold text-[22px]">Additional Details</h4>
                                            <button
                                                className="btn btn-primary btn-sm"
                                                onClick={() => handleEdit(restaurant)}
                                            >
                                                <FiEdit2 className="me-1" /> Edit Details
                                            </button>
                                        </div>
                                        <div className="flex justify-between">
                                            {/* <h5>Additional Details</h5>
                                            <p>City: {restaurant.city}</p>
                                            <p>Landmark: {restaurant.landmark}</p>
                                            <p>Pincode: {restaurant.pincode}</p>
                                            <p>Bank Details: {restaurant.bankDetails?.accountNo || 'N/A'}</p>
                                            <p>Ratings: {restaurant.ratings.join(', ')}</p> */}
                                            {/* Add more fields as needed */}
                                            <div className="">
                                                <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>NukkadName: <span className='font-semibold'>{restaurant.nukkadName || 'N/A'}</span></p>
                                                <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>City: <span className='font-semibold'>{restaurant.city || 'N/A'}</span></p>
                                                <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>CurrentAdd: <span className='font-semibold'>{restaurant.currentAddress || 'N/A'}</span></p>
                                                <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Pincode: <span className='font-semibold'>{restaurant.pincode || 'N/A'}</span></p>
                                                <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Landmark: <span className='font-semibold'>{restaurant.landmark || 'N/A'}</span></p>
                                            </div>
                                            <div className='flex gap-3 p-2'>
                                                <div className='w-[1px] h-[90%] bg-[#DBDEDA]'></div>
                                                <div>
                                                    <p className='font-medium text-[13px] leading-[15.28px] text-[#8B909A] mb-2'>OWNER INFORMATION</p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Owner Name: <span className='font-semibold'>{restaurant.ownerName || 'N/A'}</span></p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Owner Email: <span className='font-semibold'>{restaurant.ownerEmail || 'N/A'}</span></p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>PermanentAdd: <span className='font-semibold'>{restaurant.permananetAddress || 'N/A'}</span></p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Phone Number: <span className='font-semibold'>{restaurant.phoneNumber || 'N/A'}</span></p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>OperationHours: <span className='font-semibold'>{restaurant.operationalHours?.Monday || 'N/A'}</span></p>
                                                </div>
                                            </div>
                                            <div className='flex gap-3 p-2'>
                                                <div className='w-[1px] h-[90%] bg-[#DBDEDA]'></div>
                                                <div>
                                                    <p className='font-medium text-[13px] leading-[15.28px] text-[#8B909A] mb-2'>BANK INFORMATION</p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Account Number: <span className='font-semibold'>{restaurant.bankDetails?.accountNo || 'N/A'}</span></p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>IFSCcode: <span className='font-semibold'>{restaurant.bankDetails?.IFSCcode || 'N/A'}</span></p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Bank Branch: <span className='font-semibold'>{restaurant.bankDetails?.bankBranch || 'N/A'}</span></p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Latitude: <span className='font-semibold'>{restaurant.latitude || 'N/A'}</span></p>
                                                    <p className='font-normal text-[13px] text-[#23272E] leading-[22px]'>Longitude: <span className='font-semibold'>{restaurant.longitude || 'N/A'}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </React.Fragment>
                    ))}
                </tbody>
            </table>

            {/* Edit Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Edit Restaurant</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {editingRestaurant && (
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label">Nukkad Name</label>
                                <input type="text" className="form-control" value={editingRestaurant.nukkadName || ''}
                                    onChange={(e) => handleEditChange('nukkadName', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Owner Name</label>
                                <input type="text" className="form-control" value={editingRestaurant.ownerName || ''}
                                    onChange={(e) => handleEditChange('ownerName', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">City</label>
                                <input type="text" className="form-control" value={editingRestaurant.city || ''}
                                    onChange={(e) => handleEditChange('city', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Phone Number</label>
                                <input type="text" className="form-control" value={editingRestaurant.phoneNumber || ''}
                                    onChange={(e) => handleEditChange('phoneNumber', e.target.value)} />
                            </div>
                            <div className="col-md-12">
                                <label className="form-label">Nukkad Address</label>
                                <input type="text" className="form-control" value={editingRestaurant.nukkadAddress || ''}
                                    onChange={(e) => handleEditChange('nukkadAddress', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Latitude</label>
                                <input type="number" step="any" className="form-control" value={editingRestaurant.latitude || ''}
                                    onChange={(e) => handleEditChange('latitude', parseFloat(e.target.value))} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Longitude</label>
                                <input type="number" step="any" className="form-control" value={editingRestaurant.longitude || ''}
                                    onChange={(e) => handleEditChange('longitude', parseFloat(e.target.value))} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Pincode</label>
                                <input type="text" className="form-control" value={editingRestaurant.pincode || ''}
                                    onChange={(e) => handleEditChange('pincode', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Landmark</label>
                                <input type="text" className="form-control" value={editingRestaurant.landmark || ''}
                                    onChange={(e) => handleEditChange('landmark', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Owner Email</label>
                                <input type="email" className="form-control" value={editingRestaurant.ownerEmail || ''}
                                    onChange={(e) => handleEditChange('ownerEmail', e.target.value)} />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label">Status</label>
                                <select className="form-control" value={editingRestaurant.status || ''}
                                    onChange={(e) => handleEditChange('status', e.target.value)}>
                                    <option value="verified">Verified</option>
                                    <option value="unverified">Unverified</option>
                                </select>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleUpdateRestaurant}>Save Changes</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
